import { render, staticRenderFns } from "./control-box.vue?vue&type=template&id=19e6e3b7&scoped=true&"
import script from "./control-box.vue?vue&type=script&lang=js&"
export * from "./control-box.vue?vue&type=script&lang=js&"
import style0 from "./control-box.vue?vue&type=style&index=0&id=19e6e3b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e6e3b7",
  null
  
)

export default component.exports